<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<template v-if="page == 'track'">
					<userlist/>
				</template>
				<template v-if="page == 'about_parachute'">
					<div class="contact_form">
						<div class="flex flex-row mb-2">
							<input class="mr-2" type="email" v-model="contactEmail" placeholder="Email Address">
							<input class="ml-2" type="text" v-model="contactName" placeholder="Your Name">
						</div>
						<textarea class="mt-2" cols="30" rows="10" v-model="contactMessage" placeholder="Enquiry"></textarea>
					</div>
					<div class="h-align-center mt-5 mb-5">
						<button class="btn icon" @click="validateForm()">
							<svg width="25" height="17">
								<g clip-path="url(#clip_0)">
									<path fill="rgb(255,255,255)" stroke="none" d="M1.13636 0C0.521562 0 0 0.521563 0 1.13636L0 15.3409C0 15.9557 0.521562 16.4773 1.13636 16.4773L23.8636 16.4773C24.4784 16.4773 25 15.9557 25 15.3409L25 1.13636C25 0.521563 24.4784 0 23.8636 0L1.13636 0ZM23.1266 1.70455L12.4999 9.99659L1.87324 1.70455L23.1266 1.70455ZM7.46621 8.22983L1.70456 3.72869L1.70456 13.6276L7.46621 8.22983ZM23.2955 3.72869L23.2955 13.6276L17.5338 8.22983L23.2955 3.72869ZM11.9762 11.7452L8.82445 9.28608L2.9743 14.7724L22.026 14.7724L16.1754 9.28608L13.0237 11.7452C12.7152 11.9849 12.2846 11.9849 11.9762 11.7452Z" fill-rule="evenodd"/>
								</g>
							</svg>
							<span>Send</span>
						</button>
					</div>
				</template>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
//importing widgets
import textcontent from '../components/widgets/text'
import videowidget from '../components/widgets/video'
import gallerywidget from '../components/widgets/gallery'
import subsectionwidget from '../components/widgets/subsection'
import accordionwidget from '../components/widgets/accordion'
import userlist from '../components/track/userlist'

Vue.use(CxltToastr)

export default {
	components: {
		textcontent,
		videowidget,
		gallerywidget,
		accordionwidget,
		subsectionwidget,
		userlist
	},
	props:['type'],
	name: 'page',
	watch:{ // watching for route change
		$route (to, from){
				this.$nextTick(() => {
					this.getPagedata()
				})
		}
	},
	computed: { // setting list of widgets
		widgets() {
			return this.components
		}
	},
	data() {
		return {
			ps:null,
			page:'',
			pageData:[],
			components:[],
			comp:[],
			contactEmail:'',
			contactName: '',
			contactMessage: '',
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true
		}
	},
	mounted: function() {
		!localStorage.lang ? localStorage.lang = 'en' : ''
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.page = this.urlCheck('last')
			let url = this.type == 'subsection' || this.urlCheck('first') ? 'subsection/' : 'section/'
			this.axios.get(process.env.VUE_APP_URL+url+this.page, {params:{name:this.page, language:this.lang}})
			.then(response => {
				this.pageData = response.data
				this.prepareComponents()
			})
			.catch(error => {
			 	this.$router.push({path:'/404'})
			})
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.accordions && this.pageData.accordions.length > 0) {
				this.pageData.accordions.map(a => {
					a.type = 'accordionwidget'
					this.components.push(a)
				})
			}
			if(this.pageData.galleries && this.pageData.galleries.length > 0) {
				this.pageData.galleries.map(a => {
					a.type = 'gallerywidget'
					this.components.push(a)
				})
			}
			if(this.pageData.subsections && this.pageData.subsections.length > 0) {
				this.pageData.subsections.map(a => {
					a.type = 'subsectionwidget'
					this.components.push(a)
				})
			}
			if(this.pageData.videos && this.pageData.videos.length > 0) {
				this.pageData.videos.map(a => {
					a.type = 'videowidget'
					this.components.push(a)
				})
			}
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
					this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
					this.perfectScrollInit()
			})
		},
		urlCheck: function(type) { // checking path for 3 level menu and getting menu name
			let url = this.$route.path.split('/')
			return type == 'last' ? url[url.length-1] : url.length > 3 ? true : false
		},
		validateForm: function() { // only for about parachute page we validating and sending email form
			if(this.contactEmail.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your email address',
					position: 'top right',
					timeOut: 5000
				})
			} else if(this.contactName.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your name',
					position: 'top right',
					timeOut: 5000
				})
			} else if(this.contactMessage.length == 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter your enquiry',
					position: 'top right',
					timeOut: 5000
				})
			} else {
				this.axios.post(process.env.VUE_APP_URL+'contact', {
					reply_to: this.contactEmail,
					name: this.contactName,
					message: this.contactMessage
				})
				.then(response => {
					this.contactEmail = ''
					this.contactName = ''
					this.contactMessage = ''
					this.$toast.success({
						title:'Success',
						message: 'Your message was sent successfully',
						position: 'top right',
						timeOut: 5000
					})
				})
			}
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>